import { Divider as ChakraDivider } from "@chakra-ui/react";

import {
  FieldEnum,
  type Field,
  type ICallout,
  type ICombined,
  type IHeading,
  type IIframe,
  type IImage,
  type ILink,
  type ITable,
  type ITabs,
  type IText,
  type IVideo,
} from "../../../../../utils/types";
import CalloutContent from "./CalloutContent";
import { CombinedContent } from "./CombinedContent";
import HeadingContent from "./HeadingContent";
import IframeContent from "./IframeContent";
import ImageContent from "./ImageContent";
import LinkContent from "./LinkContent";
import TableContent from "./TableContent";
import TabsContent from "./TabsContent";
import TextContent from "./TextContent";
import VideoContent from "./VideoContent";

import styles from "./GuideContentBody.module.scss";

interface GuideContentBodyProps {
  fields: Field[];
}

export type IField = ICallout &
  IImage &
  IText &
  IHeading &
  ITable &
  IIframe &
  ITabs &
  IVideo &
  ILink &
  ICombined;

export const fieldComponents = {
  [FieldEnum.Callout]: CalloutContent,
  [FieldEnum.Img]: ImageContent,
  [FieldEnum.Text]: TextContent,
  [FieldEnum.Heading]: HeadingContent,
  [FieldEnum.Table]: TableContent,
  [FieldEnum.Iframe]: IframeContent,
  [FieldEnum.Tabs]: TabsContent,
  [FieldEnum.Video]: VideoContent,
  [FieldEnum.Link]: LinkContent,
  [FieldEnum.Divider]: ChakraDivider,
  [FieldEnum.Combined]: CombinedContent,
};

export function isEmpty(fields: Field[]) {
  return !fields || fields.length === 0;
}

export default function GuideContentBody({
  fields = [],
}: GuideContentBodyProps) {
  if (isEmpty(fields)) {
    return null;
  }

  return (
    <div
      id="content"
      className={styles.content}
      data-testid="guide-content-body"
    >
      {fields.map((field, fieldIndex) => {
        const Component = fieldComponents[field.type];
        if (!Component) {
          return null;
        }

        return (
          <Component
            // Math.random key는 매 렌더 리마운트를 유발(purity·pseudo-random) — 정적 목록이라 index key 사용
            key={`${field.type}-${fieldIndex}`}
            field={field as IField}
            {...field.styles}
          />
        );
      })}
    </div>
  );
}
